
(function(){
    angular.module('tmx-app').factory('RulesService', ['tmxResource','$mdMedia',
        function(tmxResource,$mdMedia){
    
    
            var Devices = tmxResource("FileUpload","http://smart-advance-poc.azurewebsites.net/api/api/v1/");
    
            //Function Declarations
            Devices.getAllDevices=getAllDevices;
            Devices.getWarehouseById = getWarehouseById;
            Devices.getActiveUnassignedDevices = getActiveUnassignedDevices;
    
    
       //Variable Declaration And Initialization
            Devices.status = [
                { LookupId: "active",
                    VisibleValue: "Active"
                },
                { LookupId: "inactive",
                    VisibleValue: "Inactive"
                },
                { LookupId: "pending",
                    VisibleValue: "Pending"
                }
            ];
    
    
            Devices.gridColumn = [
    
                {
                    field: "Name",
                    title: "Name",
                    type: "text",
                    maxlength:"20",
                    minlength:"3",
                    width:  $mdMedia('gt-sm')?'25%':'150px',
                    scrollable: false,
                    resizable: true,
                    search: true,
                    sortable: true,
                },
                {
                    field: "AccountNumber",
                    title: "Account Number",
                    type: "numeric",
                    search: true,
                    width: $mdMedia('gt-sm')?'15%':'150px',
                    minlength: "1",
                    maxlength: "15",
                    minScreenWidth: 600,
                    scrollable: false,
                    resizable: true,
                },
                {
                    field: "Salary",
                    title: "Salary",
                    type: "decimal",
                    maxlength: "15",
                    minlength:"3",
                    width:  $mdMedia('gt-sm')?'25%':'150px',
                    scrollable: false,
                    resizable: true,
                    sortable: true,
                },
                   
                {
                    width: $mdMedia('gt-sm')?'6%':'150px',
                }
            ];
    
    
            Devices.columns = angular.copy(Devices.gridColumn);

            function getAllDevices () {
    
                return Devices.all();
            }
            function getWarehouseById (id) {
                return Devices.getByAction("GetWarehouseByDistributor/"+id, true, 'get');
            }
    
    
            function getActiveUnassignedDevices(id) {
                return Devices.getByAction("GetActiveUnassignedDevices/"+id, true, 'get');
            }
    
            
            return Devices;
    
        }]);
})();
    